module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ct",
    staticStyle: {
      "color": "#D7181E"
    },
    attrs: {
      "id": "d7e6954"
    }
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_fm2_r1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("MENUS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_fm3_r1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("SUNDAY DINNER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c7_r1#d7e1",
      "id": "d6e1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("BASICS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e7094"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c9_r1#d7e2",
      "id": "d6e2"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("APPETIZERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8184"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c45_r1#d7e3",
      "id": "d6e3"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("SOUPS, STEWS & ONE-POT MEALS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8304"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c112_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("MEAT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8384"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c182_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("POULTRY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8484"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c236_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("FISH & SHELLFISH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8584"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c288_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("7.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("EGGS & CHEESE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8684"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c319_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("8.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("PASTA & PASTA SAUCES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8784"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c361_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("9.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("BEANS, RICE & OTHER GRAINS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8884"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c400_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("10.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("QUICK & EASY WEEKNIGHT MEALS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8994"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c460_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("11.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("GRILLING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9064"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c523_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("12.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("VEGETABLES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9134"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c607_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("13.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("FRUIT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9204"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c627_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("14.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("SALADS & SALAD DRESSINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8164"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c680_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("15.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("SAUCES, SALSAS & CONDIMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8174"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c708_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("16.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("CANNING & FREEZING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7ee8184"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c725_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("17.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("HOLIDAY CELEBRATIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8194"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c746_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("18.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("QUICK BREADS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8204"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c769_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("19.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("YEAST BREADS & SANDWICHES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8214"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c803_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("20.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("DESSERTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8224"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c850_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("21.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("CAKES & FROSTINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8234"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c891_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("22.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("PIES & TARTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e8075"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c1000_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#D7181E"
    }
  }, [_vm._v("23.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#558EA0"
    }
  }, [_vm._v("COOKIES & CONFECTIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8254"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c1050_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e8145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c1054_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9505"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c1055_r1#d7e26",
      "id": "d6e26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("PHOTOGRAPHY CREDITS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e9555"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c1056_r1#d7e27",
      "id": "d6e27",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("METRIC EQUIVALENT CHARTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "-0.2em",
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0005_001",
      "src": "Images/v.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4c94194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c5_r1.vue
// module id = 72
// module chunks = 0